export class AppletImageUpdateDto {
    applet_image_hdr_guid: string;
    sequence: number;
}